module.exports = __webpack_public_path__ + "img/ringDiameter.2fa5963.jpg";